<template lang="pug">
  div.fill-height
    slot(:open="open")
    ModalWrapper(
      icon="images",
      :dialog="dialog",
      :max-width="800",
      :header-text="$t(`form.media.${ isUpload ? 'upload_header': 'update_header'}`)",
      @close="close",
    )
      template(
        v-if="dialog",
        v-slot:body="",
      )
        v-row(v-show="!showScanner")
          v-col(sm="6")
            TextBox(
              :error-messages="errors.name",
              :label="$t('form.media.title')",
              :value.sync="data.name"
              @update:value="clearError('name')",
            )
          v-col(sm="6")
            Datepicker(
              :error-messages="errors.date",
              :label="$t('form.media.date')",
              :value.sync="data.date",
              @update:value="clearError('date')",
            ) .     
        v-row
          v-col(sm="12")
            Uploader(
              :error-messages="errors.media",
              :is-upload="isUpload",
              :is-video-src="data.is_video || false",
              :s3-location="data.s3_location",
              :enableScanner="$attrs['enable-scanner']",
              :value.sync="data.media",
              @toggle:scanner="showScanner = $event",
              @update:value="clearError('media')",
              @update:error="displayError($event)",
            )
        v-row(v-if="mediaTags && !showScanner")
          v-col(sm="12")
            .subtitle-1 {{ $t("form.media.media_tags") }}
            .d-flex.flex-wrap
              v-chip.mr-2.mb-2(
                v-for="mediaTag in mediaTags",
                :class="{'selectable_tag': !media_tags.includes(mediaTag.id)}",
                :color="media_tags.includes(mediaTag.id) ? 'primary' : 'grey'",
                :key="mediaTag.id",
                :outlined="!media_tags.includes(mediaTag.id)",
                @click="updateTags(mediaTag.id)",
              ) {{ stripInitialNumbers(mediaTag.name) }}
      template(v-slot:footer="")
        v-spacer
        v-btn(
          :disabled="isLoading",
          :ripple="false",
          color="primary",
          @click='close'
        ) {{ $t("form.media.cancel") }}

        v-btn(
          color="primary",
          :disabled="hasError || !valid",
          :ripple="false",
          :loading="isLoading",
          @click="submit",
        ) {{ $t(`form.media.${ isUpload ? 'upload_button': 'update_button'}`) }}
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "@/components/forms/inputs/Datepicker.vue";
import ModalWrapper from "@/components/wrapper/ModalWrapper.vue";
import Uploader from "@/components/forms/inputs/Uploader.vue";
import { tzUTC, formatDate, stripInitialNumbers } from "@/utils/helper";
import { media as mediaForm } from "@/constant/forms.js";
import { formHelper } from "@/config/mixins";
import { clone, mergeRight, pick, pluck, without } from "ramda";

export default {
  mixins: [formHelper],

  props: {
    media: {
      validator: (prop) => ["object", "undefined"].includes(typeof prop),
      required: true,
    },
  },

  components: {
    Datepicker,
    ModalWrapper,
    Uploader,
  },

  data: () => ({
    media_tags: [],
    dialog: false,
    data: {},
    isUpload: false,
    showScanner: false,
  }),

  computed: {
    ...mapGetters({
      mediaTags: "mediaTag/activeItems",
    }),
  },

  methods: {
    stripInitialNumbers,

    open(isCreate) {
      this.isUpload = isCreate;
      this.dialog = true;
      this.media_tags = [];
      this.reset();
      this.flushError();
      if (!isCreate && this.media.date.length === 24) {
        this.media.date = formatDate(this.media.date, "dd/MM/yyyy");
        this.media_tags = pluck("id", this.media.media_tags);
      }

      this.data = isCreate ? clone(mediaForm()) : clone(this.media);
      if (isCreate) {
        this.data.name = new Date().toLocaleString();
      }
    },

    close() {
      this.dialog = false;
    },

    updateTags(id) {
      if (this.media_tags.includes(id)) {
        this.media_tags = without([id], this.media_tags);
      } else {
        this.media_tags.push(id);
      }
    },

    submit() {
      if (this.validate()) {
        const action = this.isUpload ? this.create() : this.update();

        this.wrapProgress(() =>
          action
            .then(() => {
              this.$emit("updated");
              if (this.isUpload) {
                this.open(this.isUpload);
              } else {
                this.close();
              }
            })
            .catch(this.setError)
        );
      }
    },

    create() {
      const formData = new FormData();

      formData.append("media", this.data.media);
      formData.set("date", tzUTC(this.data.date));
      formData.set("name", this.data.name);
      formData.set("user_id", this.$route.params.id);
      formData.set("media_tags", this.media_tags);

      return this.$store.dispatch(`media/create`, formData, { root: true });
    },

    update() {
      const payload = mergeRight(this.data, {
        date: tzUTC(this.data.date),
      });

      return this.$store.dispatch(
        `media/update`,
        mergeRight(pick(["id", "date", "name"], payload), {
          media_tags: this.media_tags,
        }),
        { root: true }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.selectable_tag {
  &:hover {
    color: #0054a6 !important;
    border-color: #0054a6 !important;
  }
}
</style>
